import { Mail, MessageSquare, Phone } from "lucide-react";
import { useSearchParams } from "react-router-dom";

import { CanaleChat } from "@/components/admin/agenti/CanaleChat";
import { CanaleEmail } from "@/components/admin/agenti/CanaleEmail";
import { CanaleTelefono } from "@/components/admin/agenti/CanaleTelefono";
import { cn } from "@/lib/utils";

const CANALI = [
  { key: "chat", label: "Chat", Icon: MessageSquare },
  { key: "email", label: "Email", Icon: Mail },
  { key: "telefono", label: "Telefono", Icon: Phone },
];

export function AgenteConversazioni({
  slug,
  canali,
}: {
  slug: string;
  canali: string[];
}) {
  const [sp, setSp] = useSearchParams();
  const disponibili = CANALI.filter((c) => canali.includes(c.key));
  const richiesto = sp.get("canale") ?? "";
  const canale = disponibili.some((c) => c.key === richiesto)
    ? richiesto
    : (disponibili[0]?.key ?? "chat");

  const setCanale = (k: string) =>
    setSp(
      (prev) => {
        const n = new URLSearchParams(prev);
        n.set("tab", "conversazioni");
        n.set("canale", k);
        return n;
      },
      { replace: true },
    );

  return (
    <div className="space-y-4">
      <div className="inline-flex gap-1 rounded-lg bg-muted p-1">
        {disponibili.map((c) => (
          <button
            key={c.key}
            type="button"
            onClick={() => setCanale(c.key)}
            className={cn(
              "flex items-center gap-1.5 rounded-md px-3.5 py-1.5 text-[13px] font-semibold transition-colors",
              canale === c.key
                ? "bg-card text-foreground shadow-sm"
                : "text-muted-foreground hover:text-foreground",
            )}
          >
            <c.Icon className="size-4" />
            {c.label}
          </button>
        ))}
      </div>

      {canale === "chat" && <CanaleChat slug={slug} />}
      {canale === "email" && <CanaleEmail slug={slug} />}
      {canale === "telefono" && <CanaleTelefono />}
    </div>
  );
}
